export default __webpack_public_path__ + "static/media/medium_center.1da94618.png";